// @flow
import React from 'react'
import Modal from 'react-modal'
import { connect } from 'react-redux'
import { closeWelcomeModal } from '../../actions/modals'
import WelcomeContent from '../WelcomeContent'
import LinkButton from '../LinkButton'

type Props = {
  isOpen: boolean,
  closeWelcomeModal: Function
}

const WelcomeModal = ({
  isOpen,
  closeWelcomeModal // eslint-disable-line no-shadow
}: Props) => {
  if (!isOpen) return null

  return (
    <Modal
      isOpen={isOpen}
      className="modal"
      contentLabel="Welcome"
      overlayClassName="modal-overlay"
      onRequestClose={closeWelcomeModal}
    >
      <div className="modal-content">
        <div style={{ textAlign: 'right', marginBottom: '.5rem' }}>
          <button
            type="button"
            className="modal-close"
            onClick={closeWelcomeModal}
          >
            &times;
          </button>
        </div>
        <h5 style={{ marginBottom: '1rem', textAlign: 'center' }}>
          Enter to win a FREE iPad
        </h5>
        <WelcomeContent modal />
        <div style={{ margin: '2rem 0', textAlign: 'center' }}>
          <LinkButton onClick={closeWelcomeModal}>Enter Website</LinkButton>
        </div>
      </div>
    </Modal>
  )
}

export default connect(
  (state) => ({
    isOpen: state.modals.welcomeModalOpen
  }),
  {
    closeWelcomeModal
  }
)(WelcomeModal)



// WEBPACK FOOTER //
// ./src/components/WelcomeModal/index.js